<template>
  <div class="page ysts" :style="bgimg">
    
    <div :class="contentClass">
      <m-textarea>
        <div v-html="content"></div>
      </m-textarea>
      <div class="tab-title">
        <img :src="title">
      </div>
    </div>
    
    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      btnclass="ysts-nav"
      @changeNav="changeTab"
      wrap
    ></BottomNav>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import TextArea from "@/components/TextArea.vue";

export default {
  components: {
    BottomNav,
    "m-textarea": TextArea
  },
  data() {
    return {
      page: "ysts",
      currentTab: -1,
      curretTabName: "home"
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.ysts,
      ysts: "ysts",
      locale: state => state.locale
    }),
    bgimg() {
      if (this.curretTabName === "home") {
        return { backgroundImage: `url("img/ysts/home-bg.jpg")` };
      } else {
        let bgimg = this.tabs[this.currentTab].bgimg;
        return { backgroundImage: `url("${bgimg}")` };
      }
    },
    contentClass() {
      if (this.curretTabName === "home") {
        return "ysts-home";
      } else {
        return "ysts-tabs";
      }
    },
    content() {
      const tabData = this.ysts[this.curretTabName];
      return tabData ? tabData.content : "";
    },
    title() {
      if (this.curretTabName === "home") {
        return "img/ysts/home-tt.png";
      } else {
        return this.tabs[this.currentTab].ttimg;
      }
    }
  },
  watch: {
    locale(newLocale, oldLocale) {
      if (newLocale != oldLocale) {
        this.getContent({
          page: this.page,
          tab: this.curretTabName
        });
      }
    }
  },
  mounted() {
    this.getContent({
      page: this.page,
      tab: "home"
    });
  },
  methods: {
    ...mapActions(["getContent"]),
    changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      this.getContent({
        page: this.page,
        tab: tabName
      });
      this.currentTab = activeNum;
      this.curretTabName = tabName;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.ysts-nav {
  max-width: 30vw;
  margin-left: 1.2rem;
  margin-right: 1.2rem;

  @include tab1;
}

.ysts-home {
  position: relative;
  padding-top: 4rem;
  padding-left: 2rem;
  padding-right: 6rem;

  .tab-title {
    position: absolute;
    right: 1.5rem;
    top: 5rem;
    @include scaleimg(0.5);
    transform-origin: right top;
  }

  @media (max-width: 320px) {
    .tab-title {
      transform: scale(0.45);
    }
  }

  .textarea {
    height: 55vh;
    .text-main {
      padding: 0 0.5rem;
    }
    p {
      margin: 0;
    }
  }
}

.ysts-tabs {
  position: relative;
  padding-top: 3rem;
  padding-left: 6rem;
  padding-right: 1.5rem;

  .textarea {
    height: 20rem;

    .text-main {
      padding-right: 0.5rem;
    }
  }

  .tab-title {
    position: absolute;
    left: 1.5rem;
    top: 4rem;
    @include scaleimg(0.5);
  }

  @media (max-width: 320px) {
    .tab-title {
      transform: scale(0.45);
    }
  }
}
</style>
